<mode-status-banner
  class="published-banner"
  [ngClass]="{ published: fromReport }"
  status="warning"
  show-icon="true"
  layout="full-width"
>
  <span class="banner-note">{{ message }}</span>
</mode-status-banner>
